// FilterModal.jsx
import React, { useMemo } from 'react';
import {
  Modal,
  Box,
  SpaceBetween,
  Button,
  PropertyFilter,
  PropertyFilterProps,
} from '@cloudscape-design/components';

export interface FilterModalProps {
  visible: boolean;
  onDismiss: () => void;
  onApply?: () => void;
  headerText?: string;

  customGroupsText?: any;
  // PropertyFilter props
  query: PropertyFilterProps.Query;
  onChange?: any;
  loading?: boolean;
  filteringProperties: PropertyFilterProps.FilteringProperty[];
  filteringOptions: PropertyFilterProps.FilteringOption[];
  filteringPlaceholder?: string;
  countText: string;
  // Optional props
  disableFreeTextFiltering?: boolean;

  cancelButtonText?: string;
  applyButtonText?: string;
}

const FilterModal = ({
  headerText,
  // Modal props
  visible,
  cancelButtonText = 'Cancel',
  applyButtonText = 'Apply',

  // PropertyFilter props
  query,
  onChange,
  loading,
  filteringProperties,
  filteringOptions,
  filteringPlaceholder,
  countText,
  customGroupsText,

  // Optional props
  disableFreeTextFiltering = true,
  onApply,
  onDismiss,
}: FilterModalProps) => {
  const handleApply = () => {
    if (onApply) {
      onApply();
    }
    onDismiss();
  };

  const availableFilteringOptions = useMemo(
    () =>
      filteringOptions.filter(
        (option) =>
          !query.tokens?.some(
            (token) =>
              token.propertyKey === option.propertyKey && token.value === option.value,
          ),
      ),
    [filteringOptions, query.tokens],
  );

  return (
    <Modal
      data-testid="filter-model"
      visible={visible}
      onDismiss={onDismiss}
      header={headerText}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              {cancelButtonText}
            </Button>
            <Button variant="primary" onClick={handleApply}>
              {applyButtonText}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <PropertyFilter
        query={query}
        customGroupsText={customGroupsText}
        disableFreeTextFiltering={disableFreeTextFiltering}
        onChange={onChange}
        loading={loading}
        tokenLimit={4}
        filteringProperties={filteringProperties}
        filteringOptions={availableFilteringOptions}
        filteringPlaceholder={filteringPlaceholder}
        // countText={countText}
        i18nStrings={{
          enteredTextLabel: (text) => `Use: "${text}"`,
        }}
      />
    </Modal>
  );
};

export default FilterModal;
